import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const RadioInput = ({ name, label, onChange, value, checked, inputRef, tabIndex, disabled }) => {
  const radioInputClass = classnames('radio-input', {
    'radio-input--hide-label': !label,
  });

  const uniqueIdentifier = `${value}-${name}`;

  return (
    <div className={radioInputClass}>
      <input
        type="radio"
        id={uniqueIdentifier}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        ref={inputRef}
        tabIndex={tabIndex}
        disabled={disabled}
      />
      <label htmlFor={uniqueIdentifier}>
        {label && label}
      </label>
    </div>
  );
};

RadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
  checked: PropTypes.bool.isRequired,
  inputRef: PropTypes.func,
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
};

export default RadioInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/RadioInput.js